import { render, staticRenderFns } from "./full-dialog.vue?vue&type=template&id=c736b156&scoped=true"
import script from "./full-dialog.vue?vue&type=script&lang=js"
export * from "./full-dialog.vue?vue&type=script&lang=js"
import style0 from "./full-dialog.vue?vue&type=style&index=0&id=c736b156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c736b156",
  null
  
)

export default component.exports